export default {
	title: "Appel de fiches",
	initialize: "Initialiser tous les appels de fiche numéro 1",
	letter: "Lettre",
	table: {
		guideMedium: "Guide / Médium",
		noMedium: "(aucun médium)",
		noGuide: "(aucun guide)",
	},
	noLettersAvailable: "Aucune lettre disponible",
	actions: {
		"queue.reset": "réinitialisation de la file",
		"global.reset": "réinitialisation globale",
		"ticket.reset": "réinitialisation de la fiche",
	},
	clearDisplay: "Effacer l'affichage",
	confirmDevReset: "Réinitialiser TOUTES les fiches ? Cette action est irréversible.",
	displayDrawer: "Messages TV",
	exitFullscreen: "Quitter",
	fullscreen: "Plein écran",
	quickMessage: "Message rapide",
	sendToDisplay: "Envoyer à la TV",
	popup: {
		status: "Statut",
		calledAt: "Appelé à",
		call: "Appeler",
		finish: "Terminer",
		recall: "Rappeler",
		reopen: "Rouvrir",
		reset: "Réinitialiser",
		cancelledAt: "Annulé à",
		confirmReset: "Confirmer la réinitialisation de cette fiche ?",
		consultant: "Consultant",
		finishedAt: "Terminé à",
		totalTime: "Durée totale",
	},
	errors: {
		generic: "Une erreur est survenue",
		initialize: "Erreur lors de l'initialisation des appels",
		next: "Erreur lors de l'appel de la fiche suivante",
		loadRitual: "Erreur lors du chargement du rituel",
		ritualNotInProgress: "Ce rituel n'est pas en cours. Seuls les rituels ouverts permettent l'appel de fiches.",
	},
	messages: {
		called: "Fiche appelée avec succès",
		finished: "Fiche terminée avec succès",
		globalResetDone: "Réinitialisation globale effectuée",
		initialized: "Fiches initialisées avec succès",
		recalled: "Fiche rappelée",
		reconnected: "Connexion rétablie",
		reopened: "Fiche rouverte avec succès",
		resetDone: "Fiche réinitialisée",
	},
	stats: {
		called: "En service",
		completed: "Terminés",
		pending: "En attente",
	},
	devReset: "Réinitialisation dev",
};
